import React from "react"
import {useModal} from "react-modal-hook"
import Icon from "../Icon/Icon"
import {
	canReviewIncomingRealTimePaymentReturnRequest,
	IncomingRealTimePayment,
} from "../../resources/incomingRealTimePayment"
import {ApproveIncomingRtpModal} from "./ApproveIncomingRtp"
import {RejectIncomingRtpModal} from "./RejectIncomingRtp"

interface IncomingRtpButtonsProps {
	incomingRtp: IncomingRealTimePayment
	refresh: () => void
}

export function IncomingRtpButtons({incomingRtp, refresh}: IncomingRtpButtonsProps) {
	const [showReject, hideReject] = useModal(() => (
		<RejectIncomingRtpModal close={hideReject} incomingRtp={incomingRtp} onSuccess={refresh} />
	))
	const [showApprove, hideApprove] = useModal(() => (
		<ApproveIncomingRtpModal close={hideApprove} incomingRtp={incomingRtp} onSuccess={refresh} />
	))

	if (!canReviewIncomingRealTimePaymentReturnRequest(incomingRtp)) {
		return null
	}

	return (
		<>
			<button className="button is-danger" onClick={showReject}>
				<span className="icon">
					<Icon icon="interface-delete-interface-essential" size={12} />
				</span>
				<span> Reject </span>
			</button>
			<button className="button is-success" onClick={showApprove}>
				<span className="icon">
					<Icon icon="interface-validation-check--interface-essential" size={12} />
				</span>
				<span> Approve </span>
			</button>
		</>
	)
}
